<template>
  <b-button
    :disabled="isLoading"
    variant="outline-primary"
    class="late-excel-btn"
    @click="makeSheetExcel"
  >
    <b-spinner
      v-if="isLoading"
      small
      class="mr-50"
    />
    <feather-icon
      v-else
      icon="DownloadIcon"
      size="14"
      class="mr-50"
    />
    <span v-if="!isLoading">Export Excel</span>
    <span v-else>Exporting...</span>
  </b-button>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'MakeLateReasonsExcel',
  props: {
    skipPage: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    async makeSheetExcel() {
      try {
        this.isLoading = true
        const searchExcel = this.$route.query.search || ''
        const response = await axios.get(`late-reasons?search=${searchExcel}&skip=${this.skipPage}&excel=late-reasons`, {
          responseType: 'blob',
        })

        if (response.status === 200) {
          const now = new Date()
          const formattedDate = now.toISOString().split('T')[0]
          const formattedTime = now.toTimeString().split(' ')[0].replace(/:/g, '-')
          const dateTimeString = `late reason ${formattedDate}_${formattedTime}`

          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = url
          link.download = dateTimeString
          link.click()

          this.$toasted.show('Exported Successfully', {
            position: 'top-center',
            duration: 3000,
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${error}`,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
